module.exports = __webpack_public_path__ + "img/title-wap.2473a191.png";